import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import { normalizeRole } from '../../utils/userRoles';

const RoleRoute = ({ children, user, allowedRoles, fallbackPath = '/dashboard' }) => {
  // Если пользователь не загружен, ждем
  if (!user) {
    return null;
  }

  const allowedNormalized = allowedRoles.map(normalizeRole);
  const hasAccess = allowedNormalized.includes(normalizeRole(user.role));

  if (!hasAccess) {
    // Показываем сообщение об ограничении доступа вместо перенаправления
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: 'calc(100vh - 200px)',
          p: 2 
        }}
      >
        <Paper
          sx={{
            p: 4,
            textAlign: 'center',
            maxWidth: 500,
            backgroundColor: '#fafafa',
            border: '1px solid #e0e0e0'
          }}
        >
          <BlockIcon 
            sx={{ 
              fontSize: 64, 
              color: '#666', 
              mb: 2 
            }} 
          />
          <Typography variant="h5" gutterBottom color="text.secondary">
            Access Restricted
          </Typography>
          <Typography variant="body1" color="text.secondary">
            This section is not available for your account type.
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }} color="text.secondary">
            Current role: <strong>{user.role}</strong>
          </Typography>
        </Paper>
      </Box>
    );
  }

  // Если доступ разрешен, рендерим детей
  return children;
};

export default RoleRoute; 